import { BRAND_CODE } from 'config';
import { v4 as uuidv4 } from 'uuid';

const createBookingClientRequestId = () => `${BRAND_CODE}-hotels-ui-${uuidv4()}`;

export default createBookingClientRequestId;
